<template>
  <div class="div-block" :style="{color:textColor,'font-size':textSize+'px'}"><slot/>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            textColor: {
                type: String,
                default: ''
            },
            textSize: {
                type: Number,
                default: 0
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
.div-block{
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 24px;
}

</style>
